import * as yup from 'yup';

export const validationSchema = yup.object({
  title: yup.string().required('Обязательное поле.'),
  definition: yup.string().required('Обязательное поле.'),
});
